<template>
  <div class="align-items-center forgot-pass login">
    <div>
      <b-navbar type="dark" class="nav-up" toggleable="md" style="height: 35px;"></b-navbar>
      <div class="text-right">
        <b-button variant="outline-warning" class="btn btn-xs mr-2" @click="cerrarCesion">Cerrar Cesion</b-button>
      </div>
      <b-navbar toggleable="md" class="nav-down" style="height: 40px;">
        <img src="/images/logo.svg" alt="FGA" class="center" />
      </b-navbar>
    </div>
    <div>
      <b-img src="/images/FONDOS.jpg" fluid class="img-titulo"></b-img>
      <h4 class="texto-titulo">Registro de seguridad</h4>
    </div>
    <div class="col text-center" v-if="loading" style="padding-top: 100px">
        {{message_loading}}
        <img src="@/assets/images/loader.gif" alt />
      </div>
    <div class="custom-panel" v-if="!loading">
      <b-row>
        <b-col cols="5">
          <div>
            <h3 class="color-secundary">Factor de doble autenticación</h3>
            <p class="mb-4 text-justify">- Escanee el código Qr con la aplicación de Google Authenticator. <br>- Ingrese el numero de 6 dígitos generado por la aplicación y pulse el botón enviar.</p>
          </div>
          <b-form @submit="enviarCodigo" @reset="generarQr">
            <b-form-group label="Código:" label-for="codigo" :label-cols="2">
              <b-form-input id="codigo" type="text" v-model="codigo" :disabled="qr == '/images/qr_default.png'" required></b-form-input>
            </b-form-group>

            <div class="text-right">
              <b-button variant="primary" style=" margin:2%" type="reset" :disabled="qr != '/images/qr_default.png'">Generar Qr</b-button>
              <b-button variant="primary" style=" margin:2%" type="submit" :disabled="qr == '/images/qr_default.png'">Enviar</b-button>
            </div>
          </b-form>
        </b-col>
        <b-col cols="12" md="4">
          <b-col cols="4" class="label">
            <b-img :src="qr"  class="custom-qr"></b-img>
          </b-col>
            <p v-if="qr != '/images/qr_default.png'" style="padding-left:125px;">Expira en {{formattedTime == "00" ? "60" : formattedTime}} seg.</p>
            <p v-if="qr == '/images/qr_default.png'" style="padding-left:15px;">Código Qr expirado, por favor genere uno nuevo.</p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "RegistroMFA",
  data() {
    return {
      value: 30,
      max: 100,
      codigo:"",
      remainingTime: 60,
      intervalId: null,
      qr: "/images/qr_default.png",
      loading: false,
      message_loading : "Por favor espere mientras consultamos los datos..."
    };
  },
  computed: {
    formattedTime() {
      const seconds = this.remainingTime % 60;
      return `${this.pad(seconds)}`;
    },
  },
  methods: {
    async enviarCodigo(evt) {
      try{
        this.message_loading = "Por favor espere mientras verificamos los datos...";
        this.loading = true;
        let result = await this.$store.state.api.post(
          "mfa_portal/validar_codigo",
          {
            codigo: this.codigo
          }
        );
        this.$store.dispatch('user/logout')
        this.$router.push('/login');
      }catch(err){
        if (err instanceof Error) {
          this.$toasted.error(err.response.data.error, {
              theme: "toasted-primary",
              position: "top-right",
              duration: 5000,
            });
        }
        this.loading = false;
        this.message_loading = "Por favor espere mientras consultamos los datos...";
      }
    },
    async generarQr(evt) {
      try{
        this.message_loading = "Por favor espere mientras consultamos los datos...";
        this.loading = true;
        let result = await this.$store.state.api.get(
          "mfa_portal/crear"
        );
        this.codigo = "";
        this.remainingTime = 60;
        this.qr = result.data;
        this.startCountdown();
        this.loading = false;
      }catch(err){
        this.qr = "/images/qr_default.png";
      }
    },
    cerrarCesion(){
      this.$store.dispatch('user/logout')
        this.$router.push('/login');
    },
    pad(number) {
      return number.toString().padStart(2, '0');
    },
    startCountdown() {
      this.loading = false;
      this.intervalId = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--;
          if(this.remainingTime == 0){
            this.remainingTime = 60;
            clearInterval(this.intervalId);
            this.codigo = "";
            this.qr = "/images/qr_default.png";
          }
        }
      }, 1000);
    }
  },
  mounted() {
      this.generarQr();
  },
};
</script>
<style scoped>
  .custom-qr{
    border-radius: 10px !important; /* Rounded corners */
    width: 325px !important; /* Custom width */
    height: 325px !important; /* Custom height */
  }
  .custom-panel{
    padding-left: 550px;
  }
</style>